import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";

const PositiveScreeningRateChart = ({ data }) => {
  const { t } = useTranslation();

  const chartData = useMemo(() => {
    if (!data) return null;

    return {
      labels: data.tests.map((test) => t(test)),
      datasets: [
        {
          label: t("Rate per 1000 Units"),
          data: data.rates,
          backgroundColor: ["#e74c3c", "#f39c12", "#3498db", "#9b59b6", "#1abc9c"],
          borderColor: ["#e74c3c", "#f39c12", "#3498db", "#9b59b6", "#1abc9c"],
          borderWidth: 1,
          barThickness: 40,
          borderRadius: 4,
        },
      ],
    };
  }, [data, t]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            max: 2.0,
            stepSize: 0.5,
            fontColor: "#666",
            callback: (value) => value.toFixed(2),
          },
          gridLines: {
            color: "rgba(0, 0, 0, 0.1)",
          },
          scaleLabel: {
            display: true,
            labelString: t("Rate per 1000 Units"),
            fontColor: "#666",
          },
        },
      ],
      xAxes: [
        {
          ticks: {
            fontColor: "#666",
          },
          gridLines: {
            display: false,
          },
        },
      ],
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem) => {
          return `${t("Rate")}: ${tooltipItem.yLabel.toFixed(2)} ${t("per 1000 units")}`;
        },
      },
    },
  };

  if (!chartData) {
    return <p className="text-center mt-3">{t("No data available")}</p>;
  }

  return (
    <div style={{ minHeight: "280px", position: "relative" }}>
      <Bar data={chartData} height={280} options={options} />
    </div>
  );
};

export default PositiveScreeningRateChart;
